import React from 'react';
import './index.less';
import footerLogo from './LOGO_white.svg';
import wechatPng from 'assets/img/tags-code.png';
import FooterText from 'component/Footer';
import { learnLink, KnowledgeUrl } from 'constants/constants';
import { learnLinkLog } from 'utils/businesslog';

export function Footer() {
    return (
        <footer id="home-footer" className="footer">
            <div className="web-map">
                <div className="footer-logo">
                    <img src={footerLogo} />
                </div>
                <div className="friend-link">
                    {friendLinks.map((friendCategory) => (
                        <div key={friendCategory.title} className="friend-link-item">
                            <span className="title">{friendCategory.title}</span>
                            <span className="content">
                                {friendCategory.children.map((item) => (
                                    <a
                                        key={item.title}
                                        href={item.href}
                                        target="_blank"
                                        onClick={() => {
                                            // 由于学习专区是跳转外部的链接 需要改变之前的埋点方式

                                            if (item.href === learnLink) {
                                                // source 代表 1:首页 2:非首页
                                                // tab 代表 1:学习专区 2:最新动态
                                                learnLinkLog({ source: 1, tab: 1 });
                                            }
                                        }}
                                    >
                                        {item.title}
                                    </a>
                                ))}
                            </span>
                        </div>
                    ))}
                </div>
                <div className="we-chat">
                    <img src={wechatPng} />
                    <div className="main">标签手册</div>
                    <div>微信扫一扫 了解我们</div>
                </div>
            </div>
            <FooterText as="div" className="notice" />
        </footer>
    );
}

export default React.memo(Footer);

const friendLinks = [
    {
        title: '网站导航',
        children: [
            { title: '学习专区', href: KnowledgeUrl[process.env.REACT_APP_RUN_ENV] },
            {
                title: '功能动态',
                href: 'https://docs.qingque.cn/d/home/eZQADUlQqKKqS4g7plWt6zOJB?identityId=1oE1vZDL4PE#section=h.hazef1fqdiny',
            },
        ],
    },
    {
        title: '友情链接',
        children: [
            { title: '磁力引擎', href: 'https://e.kuaishou.com/' },
            { title: '信息流广告', href: 'https://ad.e.kuaishou.com/' },
            { title: '磁力聚星', href: 'https://k.kuaishou.com/' },
            { title: '作品推广（粉条）', href: 'https://e.kuaishou.com/#/e/fanstoPage' },
            { title: '客户罗盘', href: 'https://luopan.e.kuaishou.com/' },
            { title: '快手素造', href: 'https://suzao.e.kuaishou.com/#/welcome' },
            { title: '金牛电商', href: 'https://www.kuaijinniu.com/' },
            { title: '开眼快创', href: 'https://cc.e.kuaishou.com/' },
        ],
    },
    {
        title: '其他信息',
        children: [
            { title: '关于我们', href: 'https://www.kuaishou.com/about/' },
            { title: '联系我们', href: 'mailto:wanxiang.dmp@kuaishou.com' },
        ],
    },
];
